<template>
	<reqsType :baseUrlpath="baseUrlpath" :reqType="reqType"></reqsType>
</template>

<script>
	import {
		queryUrl,
		doPost
	} from '@/api/index';
	import {
		Toast
	} from 'mint-ui';
	import reqsType from '@/components/reqsType.vue'
	export default {
		name: '国货出海',
		metaInfo: {
			title: '中东华人宝-国货出海',
			meta: [{
					name: 'keyWords',
					content: '国货出海'
				},
				{
					name: 'description',
					content: '国货出海'
				}
			]
		},
		components: {
			reqsType
		},
		data() {
			return {
				baseUrlpath: '',
				reqType: '13'
			}
		},
		created() {
			this.baseUrlpath = this.baseUrl;
			var inchina = localStorage.getItem('inChina');
			if(inchina == '1'){
				this.baseUrlpath = this.baseUrlCN;
			}
		},
		methods: {}
	}
</script>

<style>
</style>